import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';
import type { ClientFindInterface } from '@zaoblako/shared/modules/client/dtos/client/client-find.dto';
import { ClientService } from '@zaoblako/web/core/services/client/client.service';
import { AutoCompleteComponent } from '@zaoblako/web/shared/dumbs/autoComplete/auto-complete/auto-complete.component';

@Component({
  standalone: true,
  selector: 'crm-client-auto-complete',
  templateUrl: './client-auto-complete.component.html',
  imports: [CommonModule, AutoCompleteComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ClientAutoCompleteComponent implements OnChanges {
  @Input() public selectedClient: ClientFindInterface;
  @Output() public selectedClientChange = new EventEmitter<ClientFindInterface>();

  @Input() public clients: ClientFindInterface[] = [];
  @Input() public isError = false;

  @Input() public class: string;
  @Input() public styleClass: string | string[] | Set<string> | { [klass: string]: any };
  @Input() public inputStyle: any;
  @Input() public inputStyleClass: string;
  @Input() public placeholder: string;
  @Input() public field = 'name';
  @Input() public disabled = false;
  @Input() public appendTo: string;
  @Input() public showClear = false;

  @Input() public customSearch = true;
  @Output() public clientSearch = new EventEmitter<string>();

  public constructor(private readonly clientService: ClientService, private readonly cdRef: ChangeDetectorRef) {}

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.selectedClient?.currentValue && !this.customSearch && !this.selectedClient.contragents) {
      this.clientService
        .findAll({ search: this.selectedClient?.name, select: ['id', 'name', 'contragents', 'externalUsers'] })
        .subscribe((clients) => {
          this.clients = clients;
          this.selectedClient = this.clients.find((_client) => _client.id === this.selectedClient?.id);
          this.cdRef.markForCheck();
        });
    }
  }

  public toClient(client: any): ClientFindInterface {
    return client as ClientFindInterface;
  }

  public searchClient(name: string) {
    this.clientService
      .findAll({ search: name, select: ['id', 'name', 'contragents', 'externalUsers'] })
      .subscribe((clients) => {
        this.clients = clients;
        this.cdRef.markForCheck();
      });
  }
}
